<script setup>
import { ref, computed } from 'vue';
import FilterOptionPill from './FilterOptionPill.vue';

const props = defineProps({
  title: { type: String, required: true },
  options: { type: Array, required: true },
  selectedIds: { type: Array, default: () => [] },
  maxVisibleItems: { type: Number, default: 8 },
});

const emit = defineEmits(['toggleOption']);

const areAllSelected = (options, selectedIds) => {
  if (!options.length) return false;
  return options.every(opt => selectedIds.includes(opt.id));
};

const expanded = ref(false);

const visibleOptions = computed(() =>
  expanded.value ? props.options : props.options.slice(0, props.maxVisibleItems)
);

const hasMore = computed(() => props.options.length > props.maxVisibleItems);

const allSelected = computed(() =>
  areAllSelected(props.options, props.selectedIds)
);

const onTitleClick = () => {
  emit(allSelected.value ? 'clearAll' : 'selectAll');
};
</script>

<template>
  <div class="border-b border-n-weak pb-4 mb-4 last:border-b-0">
    <!-- Title -->
    <button
      type="button"
      class="flex items-center justify-between w-full mb-3 text-sm font-semibold text-n-slate-12 hover:underline"
      @click="onTitleClick"
    >
      <span>{{ title }}</span>
      <span class="text-xs text-n-slate-10">
        {{ allSelected ? $t('FILTER.CLEAR_ALL') : $t('FILTER.SELECT_ALL') }}
      </span>
    </button>

    <!-- Options -->
    <div class="flex flex-wrap gap-2">
      <FilterOptionPill
        v-for="option in visibleOptions"
        :key="option.id"
        :label="option.name"
        :color="option.color"
        :selected="selectedIds.includes(option.id)"
        @toggle="emit('toggleOption', option)"
      />
    </div>

    <!-- Show more -->
    <button
      v-if="hasMore"
      type="button"
      class="mt-2 text-xs text-woot-500 hover:underline"
      @click="expanded = !expanded"
    >
      {{ expanded ? $t('FILTER.SHOW_LESS') : $t('FILTER.SHOW_MORE') }}
    </button>
  </div>
</template>
